import React, { Component } from "react";
import { Link } from "react-router-dom";

import SegmentActive from "../../../containers/SegmentList/Active";
import SegmentArchive from "../../../containers/SegmentList/Archive";
import CommonNav from "./CommonNav";
import ActionAndSearch from "./ActionAndSearch";
import "./segmentlist.css";
import { map, find, reduce, isEmpty, uniqBy } from "lodash";
import isEqual from "lodash/isEqual";
import { getUrlParameterByName } from "../../../utils/utility";

class Index extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      ifCreateAudienceFile: false, // pop out the create audience file
      list: [],
      showLoading: false,
      segment_summary: "",
      record: "",
      sourceType: "",
    };
  }

  componentDidMount() {
    this.props.loadAttributes(getUrlParameterByName("cid"));
    this.props.getSegmentArchiveData({
      clientId:
        parseInt(this.props.selected_client, 10) >= 0
          ? this.props.selected_client
          : null,
      pageNumber: 1,
      sortColumn: "archivedTime",
      pageSize: 10,
      status: "Archived",
      order: "desc",
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      segment_summary: nextProps.segment_summary,
    });
    if (nextProps.selectedSegmentSetArray.length === 1 && this.throttle) {
      nextProps.fetchSegmentSummary(nextProps.selectedSegmentSetArray[0]);
      this.throttle = false;
    }
    if (nextProps.clients !== this.props.clients) {
      if (nextProps.clients.length === 1 && nextProps.clients[0].id <= 1)
        if (nextProps.roleId === 1) this.props.history.push("/employees");
        else this.props.history.push("/clients");
    }
    if (nextProps.roleId !== this.props.roleId) {
      if (nextProps.roleId > 5) {
        if (this.props.client_info) {
          if (this.props.client_info.subscription.id > 4)
            this.props.history.push("/insights");
        }
      }
    }
    if (nextProps.client_info !== this.props.client_info) {
      if (this.props.roleId > 5) {
        if (
          nextProps.client_info &&
          nextProps.client_info.subscription.id > 4
        ) {
          this.props.history.push("/insights");
        }
      }
    }

    let itemobj = [];
    let list = []; // for final array
    if (nextProps.segment_summary) {
      if (this.props.segment_summary) {
        if (this.props.segment_summary.id !== nextProps.segment_summary.id)
          this.props.selectClient(nextProps.segment_summary.clientId);
      } else {
        this.props.selectClient(nextProps.segment_summary.clientId);
      }
    }
    if (!isEmpty(nextProps.active_segment_attributes)) {
      let rawData = JSON.parse(nextProps.active_segment_attributes.rawData);
      nextProps.segment_active_creation.selected_segments =
        rawData.selected_segments;
      nextProps.segment_active_creation.plotted_values = rawData.plotted_values;
      nextProps.segment_active_creation.selected_city = rawData.selected_city;
      nextProps.segment_active_creation.selected_state = rawData.selected_state;
      nextProps.segment_active_creation.selected_county =
        rawData.selected_county;
      nextProps.segment_active_creation.selected_dma = rawData.selected_dma;
      nextProps.segment_active_creation.zipcode = rawData.zipcode;
      nextProps.segment_active_creation.segment_name = rawData.name;
      nextProps.active_segment_attributes.rules.forEach(item => {
        nextProps.segment_active_creation.rules_id.push({
          id: item.id,
          attributeId: item.attributeId,
        });
      });
      nextProps.segment_active_creation.segment_id =
        nextProps.active_segment_attributes.id;
    }
    if (nextProps.segment_summary && nextProps.value_typehead) {
      nextProps.value_typehead.forEach(item => {
        let queryArr = JSON.parse(nextProps.segment_summary.rawData)
          .selected_segments;
        queryArr.forEach(id => {
          if (item.id === id) {
            itemobj.push(item);
          }
        });
      });

      if (
        nextProps.categories &&
        !isEqual(nextProps.categories, this.props.categories)
      ) {
        nextProps.categories.forEach(item => {
          item.attributes.forEach(attr => {
            if (attr.values) {
              attr.values.forEach(value => {
                JSON.parse(
                  nextProps.segment_summary.rawData,
                ).selected_segments.forEach(id => {
                  let attributes = [];
                  let attributes_values = [];
                  if (value.id === id) {
                    attributes_values.push(value);
                    attributes.push({
                      id: attr.id,
                      name: attr.name,
                      awId: attr.awId,
                      values: attributes_values,
                    });
                    const segmentAttr = find(list, m => {
                      return m.id === item.id;
                    });
                    if (segmentAttr === undefined) {
                      list.push({
                        id: item.id,
                        name: item.name,
                        attributes,
                      });
                    } else {
                      const _attr = find(segmentAttr.attributes, sattr => {
                        return sattr.id === attr.id;
                      });
                      if (_attr === undefined)
                        segmentAttr.attributes = segmentAttr.attributes.concat(
                          attributes,
                        );
                      else
                        _attr.values = _attr.values.concat(
                          attributes[0].values,
                        );
                    }
                  }
                });
              });
            }
            if (attr.subAttributes) {
              let subAttributes = [];
              let subAttributes_values = [];
              attr.subAttributes.forEach(attr1 => {
                attr1.values.forEach(value => {
                  JSON.parse(
                    nextProps.segment_summary.rawData,
                  ).selected_segments.forEach(id => {
                    if (value.id === id) {
                      subAttributes_values.push({
                        label: attr1.name + " - " + value.label,
                        total: value.total,
                        id: value.id,
                      });
                      subAttributes.push({
                        id: attr1.id,
                        name: attr.name,
                        parentId: attr1.parentId,
                        values: subAttributes_values,
                      });
                    }
                  });
                });
              });
              if (!isEmpty(subAttributes)) {
                list.push({
                  id: item.id,
                  name: item.name,
                  attributes: uniqBy(subAttributes, att => {
                    return att.id;
                  }),
                });
              }
            }
          });
        });
        map(list, l => {
          map(l.attributes, attr => {
            const total = reduce(
              attr.values,
              function(sum, val) {
                return (sum += val.total);
              },
              0,
            );
            attr["total"] = total;
          });
        });
        this.setState({
          list,
        });
      }
    }
  }
  handleConfirmArchive() {
    // for the multiple segment archived.
    this.props.selectedSegmentSetArray.forEach(id => {
      this.props.archiveSegment(id);
    });
    // set timeout for async call back.
    window.setTimeout(() => {
      this.props.getSegmentList({
        ...this.props.recordActiveQueryParamsObj,
        clientId:
          parseInt(this.props.selected_client, 10) >= 0
            ? this.props.selected_client
            : null,
      });
      // when use `clear` as the only parameter, empty the arrary.
      this.props.selectedSegment("clear");
    }, 800);
  }
  createAudienceFile() {
    this.setState({
      ifCreateAudienceFile: true,
    });
  }
  closeCreateCampaignDialog() {
    this.setState({
      ifCreateAudienceFile: false,
    });
  }
  checkBoxBeClick() {
    this.throttle = true;
  }
  // when click edit segment
  getComponent() {
    switch (this.props.match.params.type) {
      case "active":
        return (
          <div className="segment-list-wrapper">
            <CommonNav
              title="ACTIVE AUDIENCES"
              selected_client={this.props.selected_client}
            />

            <ActionAndSearch
              sourceType={this.state.sourceType}
              ifShowSegmentAction={true}
              onSourceTypeChange={type => {
                this.setState({
                  sourceType: type,
                });
              }}
              sortColumn={"createdTime"}
              searchByName={this.props.searchByName}
              searchByNameResult={this.props.searchByNameResult}
              client_info={this.props.client_info}
              getSegmentList={this.props.getSegmentList}
              selectedClientChanged={this.props.selectClient}
              selectedSegmentSetArray={this.props.selectedSegmentSetArray}
              getSegmentWithRules={this.props.getSegmentWithRules}
              segment_list_active={this.props.segment_list_active}
              handleConfirmArchive={() => this.handleConfirmArchive()}
              createAudienceFile={() => this.createAudienceFile()}
              segment_active_creation={this.props.segment_active_creation}
              active_segment_attributes={this.props.active_segment_attributes}
              list={this.state.list}
              segment_summary={this.state.segment_summary}
              roleId={this.props.roleId}
            />
            <SegmentActive
              sourceType={
                this.state.sourceType === "" ? undefined : this.state.sourceType
              }
              history={this.props.history}
              save_segment_report_id={this.props.match.params.id}
              roleName={this.props.roleName}
              closeCreateCampaignDialog={() => this.closeCreateCampaignDialog()}
              roleId={this.props.roleId}
              handleActiveRedirectCreate={(id, clientId) =>
                this.handleActiveRedirectCreate(id, clientId)
              }
              getCreateCampaign={this.props.getCreateCampaign}
              create_campaign={this.props.create_campaign}
              ifCreateAudienceFile={this.state.ifCreateAudienceFile}
              rollbackRequestSuccessToFalse={
                this.props.rollbackRequestSuccessToFalse
              }
              handleConfirmArchive={() => this.handleConfirmArchive()}
              checkBoxBeClick={() => this.checkBoxBeClick()}
            />
          </div>
        );
      case "archive":
        return (
          <div className="segment-list-wrapper">
            <CommonNav
              title="ARCHIVED SEGMENTS"
              selected_client={this.props.selected_client}
            />
            <ActionAndSearch
              sourceType={this.state.sourceType}
              onSourceTypeChange={type => {
                this.setState({
                  sourceType: type,
                });
              }}
              ifShowSegmentAction={false}
              history={this.props.history}
              searchByName={this.props.searchByName}
              client_info={this.props.client_info}
              getSegmentList={this.props.getSegmentList}
              searchByNameResult={this.props.searchByNameResult}
              roleId={this.props.roleId}
              sortColumn={"archivedTime"}
            />
            <SegmentArchive
              history={this.props.history}
              selectedSegmentSetArray={this.props.selectedSegmentSetArray}
              sourceType={
                this.state.sourceType === undefined
                  ? "all"
                  : this.state.sourceType
              }
            />
          </div>
        );
      default:
        return (
          <div className="segment-list-wrapper">
            <SegmentActive
              roleName={this.props.roleName}
              sourceType={
                this.state.sourceType === "" ? undefined : this.state.sourceType
              }
              history={this.props.history}
              roleId={this.props.roleId}
              save_segment_report_id={this.props.match.params.id}
              getCreateCampaign={this.props.getCreateCampaign}
              createCampaign={this.props.createCampaign}
              rollbackRequestSuccessToFalse={
                this.props.rollbackRequestSuccessToFalse
              }
            />
          </div>
        );
    }
  }

  render() {
    const hideCreateButton =
      parseInt(this.props.selected_client, 10) <= 0 ||
      this.props.roleId ===
        5; /*||
      (this.props.roleId > 3 &&
        this.props.client_info &&
        this.props.client_info.subscription &&
        this.props.client_info.subscription.id > 3)*/
    return (
      <div className="segment-list">
        <div className="segment-list-btn">
          {hideCreateButton ? (
            <button disabled className="">
              Create an Audience Segment
            </button>
          ) : (
            <a
              href={"/segments/builder?cid=" + this.props.selected_client}
              className="btn btn-default btn-aa-default"
            >
              Create an Audience
            </a>
          )}
        </div>

        {this.getComponent()}
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Segment/List/Index.jsx